<div class="container-fluid" region="uploaded files grid">
  <div class="control-section">
  </div>
  <div class="d-flex">
    <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)" [enableHtmlParse]="false"
      target=".e-ellipsistooltip" aria-hidden="true">
      <ejs-grid #grid class="grid-striped" [dataSource]="data" allowPaging="true" allowSorting="true"
        (queryCellInfo)='tooltip($event)' (actionComplete)="complete($event)" allowFiltering="true"
        [filterSettings]="filterSettings" allowExcelExport="false" allowScrolling="true" pageSizes="true | []"
        [pageSettings]="pageOptions" height='600' tabindex="0">
        <e-columns>
          <e-column field="importId" headerText="Import ID" width=140 tabindex="0">
            <ng-template #template let-data>
              <div class="d-flex">
                <div class="col-sm-8">{{data.importId}}</div>
                <div class="col-sm-2" ngbTooltip="{{data.fileMetadataGuid}} click to copy." tooltipClass = 'bs-tooltip' >
                  <a href="javascript:void(0);" (click)="copyToClipboard($event, data.fileMetadataGuid, t1)"
                    ngbTooltip="{{data.fileMetadataGuid}} copied to Clipboard!" triggers='click:blur' #t1="ngbTooltip" tooltipClass = 'bs-tooltip-copied' (mouseleave)="closeTooltip(t1)">
                    <i class="fal fa-copy left-padding-8"></i>
                  </a>
                </div>
              </div>
            </ng-template>
          </e-column>
          <e-column field="fileName" headerText="File Name" width=270 title="fileName" clipMode='EllipsisWithTooltip'>
          </e-column>
          <e-column field="fileOutcome" headerText="Import Status" width=220 clipMode='EllipsisWithTooltip'
            tabindex="0">
            <ng-template #template let-data>
              <div class="status">
                <div class="status-block" [ngClass]="getCSSClasses(data.fileOutcomeCode)">
                </div>
                <span class="collapsed">{{getFileOutcome(data?.fileOutcomeCode, data?.fileMetadataGuid,
                  data?.createDatetime)}}</span>
                <span>{{data?.fileOutcome}}</span>
              </div>
            </ng-template>
          </e-column>
          <e-column field="fileMetadataId" headerText="Import Log" width=165 [allowFiltering]="false"
            [allowSorting]="false" clipMode='EllipsisWithTooltip' tabindex="0">
            <ng-template #template let-data tabindex="0">
              Download:
              <a href="javascript:void(0)"
                (click)="downloadLog(data.fileMetadataGuid, data.importId, 'Excel')">Excel</a>
              |
              <a href="javascript:void(0)" (click)="downloadLog(data.fileMetadataGuid, data.importId, 'CSV')">CSV</a>
            </ng-template>
          </e-column>
          <e-column tabindex="0" field="totalRecords" headerText="Total" width=115 clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data>
              {{data?.totalRecords}}
            </ng-template>
          </e-column>
          <e-column tabindex="0" field="totalSuccessRecords" headerText="Imported" width=140
            clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data>
              {{data?.totalSuccessRecords}}
            </ng-template>
          </e-column>
          <e-column tabindex="0" field="totalExceptionRecords" headerText="Rejected" width=140
            clipMode='EllipsisWithTooltip'>
            <ng-template #template let-data>
              {{data?.totalExceptionRecords}}
            </ng-template>
          </e-column>
          <e-column tabindex="0" field="createUserName" headerText="Imported By" width=210
            clipMode='EllipsisWithTooltip'>
          </e-column>
          <e-column tabindex="0" field="createDatetime" headerText="Imported Date/Time" width=200 type="date"
            [format]="dateFormat" clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
    </ejs-tooltip>
  </div>
</div>
